export default {
  BASE_URL: 'https://viforbo.meridianbet.com/api',
  BASE_DOWNLOAD_URL: 'http://viforbo.meridianbet.com/',
  REST_URL: 'https://backoffice-stage.meridianbet.com/backend',
  MANAGE_APP_URL: 'http://10.10.20.70:8080/api',
  JACKPOT_URL: 'https://viforbo.meridianbet.com',
  IMG_ARENA_API: 'https://stagearena-live-stream.meridianbet.com',
}
